export default __webpack_public_path__ + "static/Ivan-3de3827c3449cc0f7b2abee9ffb99a79ea0c2d41cf7100c8f5d357b8f446e981.svg";